import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Subject } from 'rxjs';
import { GeneralConstants } from '../constants/general.constants';
import { createImgElement } from 'src/app/shared/functions/html.funtions';
import { ProfilePictureResponse } from 'src/app/core/models/response/profile-picture.response';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  private readonly DEFAULT_IMAGE = 'assets/images/user_guest.png';

  private requestingImages: boolean = false;
  private imgPlaceHolders: HTMLCollection;

  constructor(private rest: RestService) {
    this.imgPlaceHolders = document.getElementsByClassName('img-placeholder');
  }

  public async uploadImage(file: File): Promise<string> {
    const formdata: FormData = new FormData();
    formdata.append('avatar', file, file.name);

    return this.rest
      .postImage(GeneralConstants.uploadProfilePicture, formdata)
      .then((resp) => {
        if (!resp || !resp.object) {
          return '';
        }

        const response: ProfilePictureResponse = resp.object;
        const imgString = `data:${response.contentType};base64,${response.image}`;

        return imgString;
      })
      .catch((error) => {
        console.error('Error uploading image:', error);
        throw error;
      });
  }

  public requestProfileImage(userId?: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.rest
        .post(GeneralConstants.getProfilePicture, { usuarioId: userId })
        .then((resp) => {
          const response: ProfilePictureResponse = resp.object;
          const imgString = `data:${response.contentType};base64,${response.image}`;
          resolve(imgString);
        })
        .catch((error) => resolve(this.DEFAULT_IMAGE));
    });
  }

  public lazyLoadImages() {
    if (this.requestingImages || this.imgPlaceHolders.length === 0) {
      return;
    }

    this.requestingImages = true;

    const placeHolders: Element[] = Array.from(this.imgPlaceHolders);
    const usersIdsToFetch = new Set(placeHolders.map((ph) => +ph.classList[2]));

    let imgPHByUserId = {};
    usersIdsToFetch.forEach((id) => (imgPHByUserId[id] = placeHolders.filter((ph) => +ph.classList[2] == id)));

    let imgRequestsPromises = [];
    Object.keys(imgPHByUserId).forEach((userId) => {
      imgRequestsPromises.push(this.getProfileImageRequestPromise(+userId, imgPHByUserId[userId]));
    });

    Promise.all(imgRequestsPromises).then((result) => (this.requestingImages = false));
  }

  private getProfileImageRequestPromise(userId: number, elements: Element[]): Promise<any> {
    return new Promise((resolve) => {
      this.requestProfileImage(userId).then(
        (imgSrc) => {
          elements.forEach((e) => {
            const img: HTMLImageElement = createImgElement(imgSrc, 'profile-picture mr-2');
            e.replaceWith(img);
          });
          resolve(`${userId}: OK`);
        },
        (reason) => {
          elements.forEach((element) => {
            const e: HTMLImageElement = createImgElement('assets/images/user_guest.png', 'profile-picture mr-2');
            element.replaceWith(e);
          });
          resolve(`${userId}: 404`);
        }
      );
    });
  }
}
